import Vue from "vue";
import VueRouter from "vue-router";
import VueToasted from "vue-toasted";
import VueTheMask from "vue-the-mask";

import competencesAbilities from "./js/ability/competencesAbilities";
import { Can } from "@casl/vue";
import { eventBus } from "@/components/competences/event-bus";
// Needs to be this path for Scrollspy to work in IE11
import Scrollspy from "vue2-scrollspy/dist/index";
import Store from "./js/vuex-store";
import VueScrollTo from "vue-scrollto";
import Affix from "vue-affix";
import VueBreadcrumbs from "@/components/vue-components/vue-breadcrumbs/VueBreadcrumbs.vue";
import CompetenceCardsPage from "@/components/competences/competence-cards-page/CompetenceCardsPage.vue";
import CompetenceCardPage from "@/components/competences/competence-card-page/CompetenceCardPage.vue";
import CompetenceCardsBatchPage from "@/components/competences/competence-cards-batch-page/CompetenceCardsBatchPage.vue";
import ListComponent from "@/components/vue-components/list-component/ListComponent.vue";
import ListRow from "@/components/vue-components/list-row/ListRow.vue";
import ListItem from "@/components/vue-components/list-item/ListItem.vue";
import BasicInformation from "@/components/competences/basic-information/BasicInformation.vue";
import VueInput from "@/components/vue-components/vue-input/VueInput.vue";
import CompetenceCardCompetences from "@/components/competences/competence-card-competences/CompetenceCardCompetences.vue";
import CompetenceCardCourses from "@/components/competences/competence-card-courses/CompetenceCardCourses.vue";
import Modal from "./components/vue-components/modal/Modal.vue";
import DropdownVariations from "./components/vue-components/dropdown-variations/DropdownVariations.vue";
import clickOutside from "./js/utils/vue-mixins/click-outside.js";
import { createErrorService } from "./js/services/error/errorService";
import { createToastErrorHandler } from "./js/services/error/handlers/toastErrorHandler";

Vue.use(VueRouter);
Vue.use(VueToasted, {
  position: "top-center",
  fullWidth: true,
  fitToScreen: true,
  className: "c-toasted"
});
Vue.component("can", Can);
Vue.use(VueTheMask);
Vue.use(VueScrollTo);
Vue.use(Scrollspy);
Vue.use(Affix);
Vue.use(clickOutside);
const routesCompetences = [
  { path: "/", component: CompetenceCardsPage },
  { path: "/competence-card/", component: CompetenceCardPage },
  { path: "/create-competence-card/", component: CompetenceCardPage },
  { path: "/batch-competence-cards/", component: CompetenceCardsBatchPage },
  { path: "/competence-card/:id", name: "competence-card", component: CompetenceCardPage },
];

const CompetencesRouter = new VueRouter({
  routes: routesCompetences,
  /* eslint no-unused-vars: "off" */
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

Vue.prototype.$eventBus = eventBus;

const errorService = createErrorService();
errorService.use(createToastErrorHandler(Vue));

if (document.querySelector("#competencesApp")) {
  new Vue({
    el: "#competencesApp",
    store: Store,
    router: CompetencesRouter,
    ability: competencesAbilities(document.querySelector("#competencesApp")),
    components: {
      VueBreadcrumbs,
      CompetenceCardsPage,
      CompetenceCardPage,
      CompetenceCardsBatchPage,
      ListComponent,
      ListRow,
      ListItem,
      BasicInformation,
      VueInput,
      CompetenceCardCompetences,
      Modal,
      CompetenceCardCourses,
      DropdownVariations
    },
    created () {
      this.$eventBus.subscribe("error", (error) => {
        errorService.handle(error);
      });
    }
  });
}
